import api from "@/plugins/api";
/** Read a contact's consents grouped by address for the given channel list (BFF unwraps the ApiResponse envelope). */
export async function getContactConsents(contactId, channels) {
    const response = await api.post(`/contacts/${contactId}/consents`, { channels }, { unwrapEnvelope: true });
    return response.data;
}
/** Read the history timeline for one address value. */
export async function getConsentHistory(contactId, channelType, value, purpose) {
    const response = await api.get(`/contacts/${contactId}/consents/history`, {
        unwrapEnvelope: true,
        params: { channelType, value, purpose },
    });
    return response.data;
}
/**
 * Record an operator declaration — one address, N purposes, one justification, one save.
 *
 * Deliberately a single call: the acceptance criteria require one recording and one history entry,
 * so a per-purpose write would produce N unrelated audit rows and could commit halfway.
 */
export async function declareConsents(payload) {
    const response = await api.post("/opink-consent/declarations", payload, { unwrapEnvelope: true });
    return response.data;
}
/**
 * Upload a declaration's evidence file and get back the reference to attach to it.
 *
 * No upload-specific `Content-Type` here: the shared instance clears its JSON default for any
 * `FormData` body (see `plugins/api.ts`), so the browser sets the multipart boundary itself.
 */
export async function uploadConsentProof(file) {
    const form = new FormData();
    // Field name must match the BFF/OPINK action parameter (`IFormFile file`).
    form.append("file", file);
    const response = await api.post("/opink-consent/declarations/proofs", form, {
        unwrapEnvelope: true,
    });
    return response.data;
}
